module.exports = __webpack_public_path__ + "img/visa.5a67d533.svg";